<template>
  <div>
    <p class="page-info" v-if="pageInfo">{{ pageInfo }}</p>
    <v-shingaku-unit-range
      v-for="(range, index) in ranges"
      :key='index'
      :start="range.start"
      :end="range.end"
      :showAddBtn="false"
      :showRemoveBtn="false"
      :textFieldCols="textFieldCols"
      @update-start="(val) => updateShingakuUnitRange({ index: index, pages: { start: val } })"
      @update-end="(val) => updateShingakuUnitRange({ index: index, pages: { end: val } })"
      @update-error="(bool) => updateShingakuUnitRange({ index: index, pages: { error: bool } })"
      @add-range="addShingakuUnitRange"
      @remove-range="removeShingakuUnitRange({ index: index})"
    />
  </div>
</template>

<script>
import VShingakuUnitRange from '@/components/molecules/ShingakuUnitRange'
import teacher from '../../mixins/teacher';
import { mapMutations } from 'vuex'

export default {
  mixins: [teacher],

  components: {
    VShingakuUnitRange,
  },

  props: {
    textFieldCols: {
      type: Object,
      default: () => ({ lg: 3, md: 3, sm: 4 }),
    }
  },

  data: () => ({
    chapters: []
  }),

  computed: {
    ranges() {
      return this.currentSubjectCondition.shinkenkyuUnitRanges
    },

    currentSubject() {
      return this.$store.state.master.allSubjects.find(subject => subject.code === this.currentSubjectCondition.code)
    },

    selectedPublisher() {
      return this.currentSubjectCondition.selectedPublisher
    },

    pageInfo() {
      if (!this.selectedPublisher) return null

      if (this.selectedPublisher.endPage) {
        return `※${this.currentSubject.name}のページ範囲はp${this.selectedPublisher.endPage}までです。`
      }

      if (this.selectedPublisher.startPage) {
        return `※${this.currentSubject.name}のページ範囲はp${this.selectedPublisher.startPage}～です。`
      }

      return null
    },
  },

  methods: {
    ...mapMutations([
      'addShingakuUnitRange',
      'removeShingakuUnitRange',
      'updateShingakuUnitRange'
    ]),
  },
}
</script>

<style lang="stylus" scoped>
.alert-message
  color #ff0606
  font-weight bold
  font-size 14px
  margin-top 5px

.page-info
  font-size 14px
</style>
